export const visibilityTracking = {
  type: 'visibility-tracking',
  name: 'GTM: Visibility Tracking',
  icon: 'fas fa-eye',
  settings: {},
  formSchema: {
    properties: {
      name: {
        type: 'string',
        showInForm: true,
        formFieldType: 'text'
      }
    },
    required: []
  },
  allowChildren: false,
  color: 'deep-purple',
  group: 'data'
};
